<template>
    <div class="create-vehicle-page page">
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <h4 class="page-title" id="page_title">Edit Listing</h4>
                </div>
            </div>
        </div>
        <div class="card card-body">
            <div v-if="isSold">Unauthorized Page</div>
            <vehicle-form :vehicle="vehicle" ref="form" v-if="vehicle && !isSold"/>
        </div>
    </div>
</template>

<script>
import VehicleForm from "@/components/main/vehicle/Form";
import Vehicle from "@/models/vehicle";
import VehicleStatus from "@/constants/vehicle-statuses";

export default {
    mixins: [],
    components: {
        VehicleForm
    },
    data() {
        return {
            vehicle: null,
        }
    },
    computed: {
        isSold() {
            if (!this.vehicle) {
                return false
            }
            return this.vehicle.status === VehicleStatus.sold.value
        }
    },
        mounted() {

        },
        beforeRouteEnter(to, from, next) {
            Vehicle.include([
                'vehicleMake',
                'vehicleModel',
                'vehicleYear',
                'vehicleTrim',
                'transmission',
                'body',
                'condition',
                'color',
                'fuelType',
                'numberOfDoors',
                'drive',
                'media',
                'detail',
                'additionalInformation',
                'images'
            ])
                .find(to.params.id)
                .then(response => {
                    next(vm => {
                        vm.setData(response);
                    })
                })
        },
        beforeRouteLeave(to, from, next) {
            if (this.$refs.form.is_form_dirty) {
                this.$confirm('Any changes will be discard. Are you sure to leave this page?', 'Confirm', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'info'
                }).then(() => {
                    next();
                });
            } else {
                next();
            }
        },
        methods: {
            setData(response) {
                this.vehicle = response;
            }
        },
    }
</script>

<style scoped>

</style>
